import { BillingRunStatus } from "constants/billingRuns";

import { createLookupCombiner, createLookupSelectors } from "./lib";
import { selectBillingDocumentIdsByBillingRunIdLookup } from "./indexes";
import { getBillingDocuments, getBillingRuns } from "./root";

export const getBillingRunById = billingRunId => state =>
  getBillingRuns(state)[billingRunId] || null;

export const getActiveBillingRunId = state =>
  state.billingRuns.activeBillingRunId;

export const [
  selectBillingRunHasFinancialByBillingRunIdLookup,
  getBillingRunHasFinancialByBillingRunId,
] = createLookupSelectors(
  [selectBillingDocumentIdsByBillingRunIdLookup, getBillingDocuments],
  createLookupCombiner((billingDocumentIds, billingDocuments) =>
    billingDocumentIds.some(id => billingDocuments[id]?.hasFinancialChanges),
  ),
  false,
);

export const [selectIsReadOnlyByBillingRunId, getIsReadOnlyByBillingRunId] =
  createLookupSelectors(
    [getBillingRuns],
    createLookupCombiner(
      billingRun => billingRun.status === BillingRunStatus.FINISHED,
    ),
  );
